<template>
  <div class="delay-exam">
    <Header title="成绩录入查询" type="0" route="/homeIndex" ></Header>
    <div class="delay-search">
      <i class="search-icon" @click="delaySearch()"></i>
      <input type="text" placeholder="搜索课程名称或课程编号" v-model="courseInfo"  @keyup.enter="delaySearch()">
    </div>
    <div class="search-info">
      <div class="sem-drop">
        <div @click="semPicker = true"><p>{{this.semester}}</p><i></i></div>
        <div @click="actTap()"><p>{{this.activity}}</p><i></i></div>
      </div>
      <van-popup v-model="semPicker" position="bottom">
        <van-picker show-toolbar :columns="option1" @cancel="semPicker = false" @confirm="semConfirm" :swipe-duration="500" :item-height="35"/>
      </van-popup>
      <van-popup v-model="actPicker" position="bottom">
        <van-picker show-toolbar :columns="option2" @cancel="actPicker = false" @confirm="actConfirm" :swipe-duration="500" :item-height="35"/>
      </van-popup>
    </div>
    <NOdata v-if="this.allWarnList.length == 0" title="暂无课程数据~"></NOdata>
    <div v-else :style="'min-height: '+this.minHeight+'px'">
      <a class="grey-contain" v-for="(item,index) in allWarnList" :key="index" @click="goApply(item.cj0703id,item.cj0701id)">
        <div>
          <p class="contain-txt">{{item.kcmc}}({{item.kch}})</p>
          <p class="contain-txt1">开课单位：{{item.dwmc}}</p>
          <p class="contain-txt1">班级名称：{{item.ktmc}}</p>
          <p class="contain-txt1">未录人数/人数：{{item.wlrs}}/{{item.xkrs}}</p>
          <p class="contain-txt1">课程属性：{{item.kcsx}}</p>
        </div>
         <i class="arrow_link"></i>
      </a>
    </div>

  </div>
</template>

<script>
    import { Api } from "../../../utils/axios";
    export default {
        data() {
            return {
                casLogin:sessionStorage.getItem('casLogin'),
                allWarnList:[],
                activityValue:'',
                semPicker:false,
                actPicker:false,
                semester:'学年学期',
                curSemester:'',
                activity:'活动名称',
                value1: 0,
                courseInfo:'',
                option1: [{
                    text:'学年学期',
                    value:0,
                    index:''
                }],
                option2: [{
                    text:'活动名称',
                    value:0,
                    index:''
                }],
                activityid:'',
                isLoad:false,
                minHeight:200,
            }
        },
        created(){
            this.getMain()
        },
        methods:{
            async getMain(){
                const res = await Api.getCjllcx()
                if(res.dqxnxqList.length>0){
                    this.curSemester = res.dqxnxqList[0].xnxq01id;
                    this.semester = res.dqxnxqList[0].xnxq01id;
                }
                this.getSlow(this.semester)
                //学年学期
                let concatList = []
                res.xnxqList.forEach((item,index) => {
                    concatList[index] = {
                        text:item.xnxqmc,
                        value:index + 1,
                        index:item.xnxq01id
                    }
                });
                this.option1 = this.option1.concat(concatList)
                this.getActivity(this.semester)
            },
            async getSlow(val){
                const params = {
                    xnxqid:val,
                    cj0701id:this.activityid == '活动名称' ? '' : this.activityid,
                    type:"kclist"
                }
                const res = await Api.getCjllcx(params)
                this.allWarnList = res.data;
                this.minHeight=300+82*res.data.length;
                this.isLoad = true;
            },
            actTap(){
                if(this.semester===""||this.semester=="学年学期"){
                    this.$toast.fail('请选择学年学期')
                    return  false
                }
                this.actPicker = true
            },
            semConfirm(e,val){
                this.semPicker = false;
                if(e.text == '学年学期'&&this.curSemester!=""){
                    this.semester = this.curSemester
                }else{
                    this.semester = e.text
                }
                this.activityid="";
                this.activity="活动名称";
                this.getActivity(this.semester)
                this.delaySearch();
            },
            actConfirm(e,val){
                this.actPicker = false;
                this.activity = e.text
                this.activityid = e.index
                this.delaySearch()
            },
            goApply(cj0703id,cj0701id){
                if(sessionStorage.getItem("schoolCode")=='11441'){
                    this.$router.push({
                    path:'/teacher/scoreEntryDetails_jljc',
                    query:{
                        'cj0703id':cj0703id,
                        'cj0701id':cj0701id
                    }
                })
                }else{
                    this.$router.push({
                    path:'/teacher/scoreEntryDetails',
                    query:{
                        'cj0703id':cj0703id,
                        'cj0701id':cj0701id
                    }
                })
                }
                
            },
            async delaySearch(){
                if(this.semester===""||this.semester=="学年学期"){
                    this.$toast.fail('请选择学年学期')
                    return  false
                }
                const params = {
                    xnxqid:this.semester,
                    search:this.courseInfo,
                    cj0701id:this.activityid == '活动名称' ? '' : this.activityid,
                    type:"kclist"
                }
                const res = await Api.getCjllcx(params)
                this.$store.state.courseInfo = this.courseInfo;
                this.$store.state.value1 = this.value1
                this.allWarnList = res.data;
                this.minHeight=300+82*res.data.length;
                this.$store.state.allWarnList = this.allWarnList
            },
            async getActivity(xnxqid) {
                const params = {
                    xnxqid: xnxqid,
                }
                const res = await Api.getCjllcx(params)
                //活动名称
                this.option2 = [{
                    text: '活动名称',
                    value: 0,
                    index: ''
                }]
                let activityList = []
                res.cjllList.forEach((item, index) => {
                    activityList[index] = {
                        text: item.cjlrmc,
                        value: index + 1,
                        index: item.cj0701id
                    }
                });
                this.option2 = this.option2.concat(activityList)
            }
        },
    }
</script>

<style lang="less" scoped>
  .grey-contain{ min-height: 130px;}
  .delay-exam .grey-contain .contain-txt{line-height: 22px;}
  .delay-exam .grey-contain .contain-txt1{line-height: 17px;}
  .delay-search{background-color: @attendance-background-color-6;border-radius:3px;margin: 20px 20px 0;padding: 11px 12px;display: flex;}
  .search-icon{background: url(../../../../static/img/search.png)no-repeat center;width: 20px;height: 20px;background-size: 100%;}
  .delay-search input{background-color: @attendance-background-color-6;padding-left: 11px;flex: 1;color: @attendance-color-2;}
  .search-info{display: flex;justify-content: center;border-bottom: 1px solid @attendance-border-color-6;padding: 20px 0 7px;}
  .search-info input{width: 40%;text-align: center;padding: 10px 0}
  .delay-btn{position: fixed;padding: 20px;width: 100%;text-align: center;bottom: 0;background-color: @attendance-color-3;box-sizing: border-box;}
  .delay-btn button{background-color: @attendance-background-color-7;color: @attendance-background-color-1;padding: 11px 0;width: 100%;border-radius: 3px;}
  .grey-contain:last-child{margin-bottom: 80px;}
  .search-info .sem-drop,.search-info .sem-drop div{display: flex;align-items: center;color: @attendance-color-2;font-size: 14px;justify-content: center;}

  .search-info .sem-drop{width: 80%;}
  .search-info .sem-drop>div{width: 45%;text-align: center;display: flex;align-items: center;justify-content: center;}
  .search-info .van-popup.van-popup--bottom{border-radius: 5px 5px 0 0;}/*box-shadow:0px -2px 2px 0px rgba(223,223,223,0.5);*/
  .search-info .sem-drop p{overflow: hidden;text-overflow: ellipsis;white-space: nowrap;text-align: right;}
  .search-info .sem-drop>div{position: relative}
  .search-info .sem-drop>div i{background: url(../../../../static/img/Triangle.png)no-repeat center;width: 10px;height: 10px;background-size: 10px 8px;margin-left: 5px;}
  .search-info .van-ellipsis.van-picker-column__item.van-picker-column__item--selected{font-weight: 600;color: @attendance-color-1;}
  .search-info .van-picker__columns::before{width: 150px;height: 1px;background-color: @attendance-background-color-2;content: '';position: absolute;top: 70px;left: 50%;transform: translateX(-50%)}
  .search-info .van-picker__columns::after{width: 150px;height: 1px;background-color: @attendance-background-color-2;content: '';position: absolute;bottom: 70px;left: 50%;transform: translateX(-50%)}

</style>



// WEBPACK FOOTER //
// src/components/teacher/scoreEntry/index.vue